import { GAMES_DOC } from '@awwyeah/shared';
import type { WebModule } from '../registry';
import { GameBoardPage } from './GameBoardPage';
import { FriendGamePage, FriendLoungePage } from './FriendLoungePage';
import { GuestPlayPage } from './GuestPlayPage';
import { GamesPage, LegacyGameRedirect } from './GamesPage';

/**
 * Games (client side, WS-17a): Connect-4. No `nav` entry — the brief is explicit that this
 * doesn't get a 7th bottom-tab; `GamesSection` renders inside the existing Apps tab
 * (`apps/web/src/modules/apps/AppsIndexPage.tsx` imports it from this module's published
 * `index.ts`, the one deliberate cross-feature-module exception beyond `sharing`/`lists`'
 * existing ones — see docs/DECISIONS.md 2026-08-03). The board route still needs to exist
 * here so it's reachable, same as `household`/`dev` (no-nav modules, docs/DECISIONS.md
 * 2026-07-31).
 */
export const gamesWebModule: WebModule = {
  id: 'games',
  // Its own tab since 2026-11-03 (owner ask: the Apps tab was filling up with games).
  nav: { label: 'Games', path: '/games', icon: '🎮', order: 45 },
  routes: [
    { path: '/games', component: GamesPage },
    { path: '/games/:gameId', component: GameBoardPage },
    // Old links (pushes, the feed, bookmarks) still land on the board.
    { path: '/apps/game/:gameId', component: LegacyGameRedirect },
    // WS-23. Public — the one module route in the app that renders for somebody with no
    // household account at all; `router.tsx`'s `PUBLIC_MODULE_ROUTES` is what makes it so.
    { path: '/play/:token', component: GuestPlayPage },
    // Friend of the family: the guest lounge and a friend's own matches. Public in the same
    // way — authorised by the guest session cookie server-side, never by the household one.
    // (react-router ranks the static `/play/lounge` above `/play/:token`.)
    { path: '/play/lounge', component: FriendLoungePage },
    { path: '/play/g/:gameId', component: FriendGamePage },
  ],
  docs: [GAMES_DOC, 'game:'],
};

export { GamesSection } from './GamesSection';
export { YourTurnProbes, useYourTurnCount } from './useYourTurnCount';
